"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const taquito_1 = require("@taquito/taquito");
const ASSET_CODE = 'XTZ-USD';
class HarbingerClient {
    constructor(nodeUrl, normalizerAddress) {
        this.normalizerAddress = normalizerAddress;
        this.tezos = new taquito_1.TezosToolkit(nodeUrl);
    }
    async getPriceData() {
        const normalizerContract = await this.tezos.contract.at(this.normalizerAddress);
        const normalizerStorage = await normalizerContract.storage();
        const assetData = await normalizerStorage.assetMap.get(ASSET_CODE);
        return {
            time: new Date(assetData.lastUpdateTime),
            price: assetData.computedPrice,
        };
    }
}
exports.default = HarbingerClient;
//# sourceMappingURL=harbinger-client.js.map